var RESET_SECURITY_FLOW_TYPE = /* @__PURE__ */ ((RESET_SECURITY_FLOW_TYPE2) => {
  RESET_SECURITY_FLOW_TYPE2["PASSWORD"] = "password";
  RESET_SECURITY_FLOW_TYPE2["TOTP"] = "totp";
  return RESET_SECURITY_FLOW_TYPE2;
})(RESET_SECURITY_FLOW_TYPE || {});
export {
  RESET_SECURITY_FLOW_TYPE
};
